import { useLanguageContext } from "../../../context/LanguageContext";
import ParkingLocationsPage from "../../../pages/parking_locations/index/ParkingLocationsPage";
import { useParkingLocationsRouteValidator } from "../../validators/parking_locations/ParkingLocationsRouteValidator";
import { RouteConfig } from "../RouteConfig";

/**
 * The route config which contains static information about the route
 * @returns {{ path, label, validator, getPage, getRouteElement }}
 */
function useParkingLocationsRouteConfig() {
  const { translate } = useLanguageContext();

  return new RouteConfig()
    .setPath("/dashboard/parking_locations")
    .setLabel(translate("eva.main.entities.parking_locations"))
    .setValidator(useParkingLocationsRouteValidator())
    .setPage(<ParkingLocationsPage />);
}

export default useParkingLocationsRouteConfig;
